<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="71" height="52" fill="white" />
    <path
      opacity="0.8"
      d="M7.56055 47.0088C8.26067 47.0089 8.82812 47.5762 8.82812 48.2764C8.82812 48.9765 8.26067 49.5438 7.56055 49.5439C6.86033 49.5439 6.29297 48.9766 6.29297 48.2764C6.29297 47.5762 6.86033 47.0088 7.56055 47.0088ZM35.4531 3.53906C47.957 3.53906 58.0938 13.6758 58.0938 26.1797C58.0936 38.6835 47.9569 48.8193 35.4531 48.8193C22.9493 48.8193 12.8126 38.6834 12.8125 26.1797C12.8125 13.6758 22.9493 3.5391 35.4531 3.53906ZM63.708 5.71289C65.8087 5.71289 67.5117 7.41595 67.5117 9.5166C67.5115 11.6171 65.8085 13.3193 63.708 13.3193C61.6076 13.3192 59.9045 11.617 59.9043 9.5166C59.9043 7.41605 61.6075 5.71305 63.708 5.71289Z"
      fill="url(#paint0_radial_410_32629)"
    />
    <g filter="url(#filter0_d_410_32629)">
      <path
        d="M34.2833 14.3198C34.7409 13.508 35.9099 13.508 36.3675 14.3198L39.6128 20.0776C39.7835 20.3804 40.0775 20.5941 40.4183 20.6628L46.8972 21.97C47.8106 22.1544 48.1719 23.2662 47.5412 23.9522L43.0681 28.818C42.8328 29.0739 42.7205 29.4195 42.7604 29.7649L43.5192 36.3306C43.6262 37.2563 42.6804 37.9435 41.8331 37.5556L35.8232 34.8051C35.5071 34.6604 35.1437 34.6604 34.8276 34.8051L28.8177 37.5556C27.9704 37.9435 27.0246 37.2563 27.1316 36.3306L27.8904 29.7649C27.9303 29.4195 27.818 29.0739 27.5827 28.818L23.1096 23.9522C22.4789 23.2662 22.8402 22.1544 23.7536 21.97L30.2325 20.6628C30.5733 20.5941 30.8673 20.3804 31.038 20.0776L34.2833 14.3198Z"
        fill="url(#paint1_radial_410_32629)"
      />
    </g>
    <mask
      id="mask0_410_32629"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="22"
      y="13"
      width="26"
      height="25"
    >
      <path
        d="M34.2833 14.3198C34.7409 13.508 35.9099 13.508 36.3675 14.3198L39.6128 20.0776C39.7835 20.3804 40.0775 20.5941 40.4183 20.6628L46.8972 21.97C47.8106 22.1544 48.1719 23.2662 47.5412 23.9522L43.0681 28.818C42.8328 29.0739 42.7205 29.4195 42.7604 29.7649L43.5192 36.3306C43.6262 37.2563 42.6804 37.9435 41.8331 37.5556L35.8232 34.8051C35.5071 34.6604 35.1437 34.6604 34.8276 34.8051L28.8177 37.5556C27.9704 37.9435 27.0246 37.2563 27.1316 36.3306L27.8904 29.7649C27.9303 29.4195 27.818 29.0739 27.5827 28.818L23.1096 23.9522C22.4789 23.2662 22.8402 22.1544 23.7536 21.97L30.2325 20.6628C30.5733 20.5941 30.8673 20.3804 31.038 20.0776L34.2833 14.3198Z"
        fill="url(#paint2_radial_410_32629)"
      />
    </mask>
    <g mask="url(#mask0_410_32629)">
      <g opacity="0.8" filter="url(#filter1_f_410_32629)">
        <path
          d="M34.5439 14.4668C34.8871 13.8579 35.7642 13.8579 36.1074 14.4668L39.3525 20.2246C39.5659 20.603 39.9335 20.8701 40.3594 20.9561L46.8379 22.2637C47.523 22.4019 47.7943 23.2355 47.3213 23.75L42.8477 28.6152C42.5537 28.935 42.4131 29.3673 42.4629 29.7988L43.2217 36.3652C43.3017 37.0592 42.5933 37.5745 41.958 37.2842L35.9473 34.5332C35.5522 34.3525 35.0982 34.3524 34.7031 34.5332L28.6934 37.2842C28.058 37.5749 27.3487 37.0593 27.4287 36.3652L28.1875 29.7988C28.2373 29.3673 28.0967 28.9351 27.8027 28.6152L23.3301 23.75C22.8572 23.2356 23.1277 22.4021 23.8125 22.2637L30.292 20.9561C30.7178 20.87 31.0855 20.6031 31.2988 20.2246L34.5439 14.4668Z"
          stroke="white"
          stroke-width="0.598113"
        />
      </g>
    </g>
    <circle
      cx="42.7717"
      cy="41.4624"
      r="0.692314"
      transform="rotate(-91.0315 42.7717 41.4624)"
      fill="url(#paint3_radial_410_32629)"
      stroke="white"
      stroke-width="0.258895"
    />
    <circle
      cx="51.7443"
      cy="27.7046"
      r="0.692314"
      transform="rotate(-91.0315 51.7443 27.7046)"
      fill="url(#paint4_radial_410_32629)"
      stroke="white"
      stroke-width="0.258895"
    />
    <path
      d="M24.4184 16.0236L24.4737 16.002L24.4941 15.946L24.9214 14.7213L25.3944 15.9298L25.4159 15.9851L25.4719 16.0046L26.6966 16.4338L25.4881 16.9048L25.4328 16.9273L25.4133 16.9833L24.9842 18.2081L24.5131 16.9995L24.4906 16.9443L24.4346 16.9238L23.2099 16.4966L24.4184 16.0236Z"
      fill="url(#paint5_radial_410_32629)"
      stroke="white"
      stroke-width="0.258895"
    />
    <path
      d="M20.2309 34.2657L20.2862 34.2442L20.3066 34.1882L20.7339 32.9635L21.2069 34.172L21.2284 34.2273L21.2844 34.2468L22.5091 34.676L21.3006 35.147L21.2453 35.1695L21.2258 35.2255L20.7967 36.4502L20.3256 35.2417L20.3031 35.1865L20.2471 35.166L19.0224 34.7387L20.2309 34.2657Z"
      fill="url(#paint6_radial_410_32629)"
      stroke="white"
      stroke-width="0.258895"
    />
    <path
      d="M46.0835 12.7754L46.1388 12.7549L46.1592 12.6988L46.8436 10.8347L47.5955 12.673L47.618 12.7283L47.674 12.7468L49.6068 13.3908L47.6985 14.104L47.6432 14.1245L47.6227 14.1806L46.9374 16.0457L46.1864 14.2064L46.1639 14.1511L46.1079 14.1326L44.1741 13.4886L46.0835 12.7754Z"
      fill="url(#paint7_radial_410_32629)"
      stroke="white"
      stroke-width="0.258895"
    />
    <defs>
      <filter
        id="filter0_d_410_32629"
        x="16.8118"
        y="7.7298"
        width="37.0287"
        height="35.9173"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2.99057" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.639216 0 0 0 0 0.694118 0 0 0 0 0.819608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_410_32629"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_410_32629"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_f_410_32629"
        x="20.9986"
        y="11.9166"
        width="28.6551"
        height="27.5438"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.89717"
          result="effect1_foregroundBlur_410_32629"
        />
      </filter>
      <radialGradient
        id="paint0_radial_410_32629"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(57.0915 -8.59608) rotate(119.687) scale(72.7621 80.7098)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_410_32629"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(44.8197 46.3771) rotate(-111.67) scale(41.1389 65.0479)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_410_32629"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(44.8197 46.3771) rotate(-111.67) scale(41.1389 65.0479)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_410_32629"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(43.9929 42.6714) rotate(-134.906) scale(2.89396 3.22794)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_410_32629"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(52.9656 28.9136) rotate(-134.906) scale(2.89396 3.22794)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_410_32629"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.011 13.2628) rotate(134.062) scale(7.45524 8.31563)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_410_32629"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.8235 31.505) rotate(134.062) scale(7.45524 8.31563)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_410_32629"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(51.379 8.95382) rotate(135.394) scale(10.6895 11.9085)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
    </defs>
  </svg>
</template>
